import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {userAccountChange} from 'src/openapi/admin/apis/UserAccountChangeApi';
import {userAccountChangeV2} from 'src/openapi/admin/apis/UserAccountChangeV2Api';
import {useAppDispatch} from 'src/store/hooks';

import type {UserAccountChangeV2$Request} from 'src/openapi/admin/apis/UserAccountChangeV2Api';
import type {UserSearchesReplaceResponse} from 'src/openapi/admin/models/UserSearchesReplaceResponse';

type EventActionResult = ReturnType<ReturnType<typeof useAppDispatch>>;

export const useSaveChangeAccount = (
    onSuccess?: (data: UserSearchesReplaceResponse) => void,
) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((meta: UserAccountChangeV2$Request) => {
        return (onSuccess
            ? apiDispatch(userAccountChangeV2(meta))
            : apiDispatch(userAccountChange(meta))
        ) as EventActionResult;
    }, [apiDispatch, onSuccess]);

    return useCommonEventHook<UserAccountChangeV2$Request, UserSearchesReplaceResponse>({
        eventAction,
        onSuccess,
    });
};
